/**
 * Utility to handle Microsoft Bing UET tag issues
 * Fixes the "this.shouldEnforce is not a function" error by ensuring the method exists
 */
export default class BingTag {
  static setupSafetyCheck() {
    if (import.meta.server) return

    window.addEventListener('load', () => {
      if (window.uetq && !window.uetq.shouldEnforce) {
        if (typeof window.uetq.shouldEnforce !== 'function') {
          const originalValue = window.uetq.shouldEnforce
          window.uetq.shouldEnforce = function () {
            return originalValue
          }
          console.debug('Fixed Microsoft Bing UET shouldEnforce method')
        }
      }
    })
  }
}
